import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeEvery } from 'redux-saga/effects';

import { companyGuestsFetched, companyGuestsFetchFailed, fetchCompanyGuests, FetchCompanyGuestsPayload } from '@/store/actions/company/fetchCompanyGuests';

import { waitBeforeFetch } from '../../../utils/FetchState';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* fetchCompanyGuestsSaga({ payload }: Action<FetchCompanyGuestsPayload>) {
  const timestamp = moment();
  const token = yield getAuthenticationToken();
  const { fetchState, companyUuid } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getCompanyGuests, token, { companyUuid });
  const { guests, error } = response;
  if (!error) {
    const responsePayload = {
      guests,
      timestamp,
    };
    const responseAction = companyGuestsFetched(responsePayload);
    yield put(responseAction);
  } else {
    const responseAction = companyGuestsFetchFailed({ timestamp, companyUuid });
    yield put(responseAction);
  }
}

export default function* watchFetchCompanyGuestsSaga() {
  yield takeEvery(fetchCompanyGuests, fetchCompanyGuestsSaga);
}
